<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>

            <!-- 策略优先级 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.policyorder1") }}</span>

                <div class="switch1">
                    <div class="main">
                        <p>

                            <el-alert :title="this.load_hind1" type="warning" show-icon :closable="false"></el-alert>
                        </p>
                    </div>
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName" v-loading='loading'>
                            <el-table-column prop="RECSEQ" :label="$t('logs.policyorder2')" width="120"> </el-table-column>
                            <el-table-column prop="SHOWTYPE" :label="$t('logs.policyorder3')">
                            </el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <el-button type="text" :disabled="scope.$index == 0 ||scope.$index == 3 ||$root.jurisdiction.only_query==0"  @click="moveUpward(scope.row, scope.$index)">上移</el-button>
                                    <el-button type="text" :disabled="(scope.$index ==3||scope.$index == 2 ||$root.jurisdiction.only_query==0) " @click="moveDown(scope.row, scope.$index)">下移</el-button>
                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu">
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>

        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",
            loading:false,
            tableData: [{
                address: "1",
            }, {
                address: "2",
            }, {
                address: "3",
            }, {
                address: "4",
            }, {
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            radio: [],
            load_hind1: '',
            doaction: "",
            type: '',
        };
    },
    mounted() {
        this.getFileList()
    },
    methods: {
        // 加载
        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_policy_order",
                        sid: sid,
                        doaction: this.doaction,
                        type: this.type
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList = res.data.ret.datalist;
                        this.load_hind1 = res.data.ret.LOAD_HINT;
                        this.actionn = res.data.ret.q_action;
                        // this.action = res.data.ret.ACTION;
                         this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss2")}`,
                        });

                        // 总条数

                        this.loading = false;

                    }
                })
               
        },
        moveUpward(row, index) {
            console.log(row, index)
            if (index > 0) {
                // let upData = this.tableData[index - 1];
                // this.tableData.splice(index - 1, 1);
                // this.tableData.splice(index, 0, upData);
                this.doaction = 'up'
                this.type = row.TYPE
                this.getFileList()
            } else {
                this.$message({
                    message: '已经是第一条，上移失败',
                    type: 'warning'
                });
            }
        },
        moveDown(row, index) {
            console.log(row, index)

            if ((index + 1) == this.tableData.length) {
                this.$message({
                    message: '已经是最后一条，下移失败',
                    type: 'warning'
                });
            } else {
                // let downData = this.tableData[index + 1];
                // this.tableData.splice(index + 1, 1);
                // this.tableData.splice(index, 0, downData);
                this.doaction = 'down'
                this.type = row.TYPE
                this.getFileList()
            }
        },

        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-table {
    height: calc(70vh - 20px);
}

/deep/ .el-tabs__nav {
    padding-left: 16px;
}
</style>
